import handleResponse from './request/handleResponse'

export const makeBoxBuyConnectIntegration = (api: GlobalFetch) => async () => {
  const response = await api.fetch(`/api/v2/boxbuy/connect`, { method: 'POST' })
  return await handleResponse(response)
}

export const makeBoxBuyDisconnectIntegration = (api: GlobalFetch) => async () => {
  const response = await api.fetch(`/api/v2/boxbuy/disconnect`, { method: 'POST' })
  return await handleResponse(response)
}

export const makeBoxBuyStatusIntegration = (api: GlobalFetch) => async () => {
  const response = await api.fetch(`/api/v2/boxbuy/index`)
  return await handleResponse(response)
}
